import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dropzone from 'react-dropzone';
import { reduxForm, Form, Field } from 'redux-form';
import MaterialGrid from '@material-ui/core/Grid';
import { FORM_RULES } from 'helpers/validations';
import AlertDialogSlide from 'common/components/dialog/dialog';
import { InputSwitch } from 'common/components/fields/InputSwitch';
import { InputLabelOutlined } from 'common/components/fields/InputLabelOutlined';
import PrimaryButton from 'common/components/buttons/primaryButton';
import LoadingProgress from 'common/components/progress/loading';
import csv from 'csv';
import { Box } from '@material-ui/core';
import OnboardingCard from 'common/components/cards/onboardingCard/onboardingCard';
import { USER_TOKEN } from 'config/consts';
import { validateToken } from 'pages/auth/authActions';
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { cpfMask } from '../../../../helpers/masks';
import {
  postCsvFileToContacts,
  postContacts,
  clearCsvImportResults,
  postCsvFileToDeleteContacts,
  clearCsvDeleteResults,
} from './contactsActions';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      import: '',
      contacts: [],
      fileError: '',
      deleteFileError: '',
    };
  }

  handleFile = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;
    const ext = file.name.split('.').pop().toLowerCase();
    if (!['csv', 'xlsx', 'xls'].includes(ext)) {
      this.setState({
        fileError: `Formato inválido: "${file.name}". Envie um arquivo .csv, .xlsx ou .xls.`,
      });
      return;
    }
    this.setState({ fileError: '' });
    const isCsv = ext === 'csv';
    const reader = new FileReader();
    const sendRows = (rows) => {
      this.props.postCsvFileToContacts(rows, this.props.auth.user.establishments[0].id);
    };
    reader.onload = (evt) => {
      if (isCsv) {
        Papa.parse(evt.target.result, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => sendRows(results.data),
        });
        return;
      }
      // arquivos .xlsx/.xls precisam ser lidos como binário, ao contrário do .csv (texto)
      const workbook = XLSX.read(evt.target.result, { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
      sendRows(jsonData);
    };
    if (isCsv) {
      reader.readAsText(file, 'UTF-8');
    } else {
      reader.readAsBinaryString(file);
    }
  };

  handleDeleteFile = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;
    const ext = file.name.split('.').pop().toLowerCase();
    if (!['csv', 'xlsx', 'xls'].includes(ext)) {
      this.setState({
        deleteFileError: `Formato inválido: "${file.name}". Envie um arquivo .csv, .xlsx ou .xls.`,
      });
      return;
    }
    this.setState({ deleteFileError: '' });
    const isCsv = ext === 'csv';
    const reader = new FileReader();
    reader.onload = (evt) => {
      if (isCsv) {
        Papa.parse(evt.target.result, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.props.postCsvFileToDeleteContacts(
              results.data,
              this.props.auth.user.establishments[0].id
            );
          },
        });
        return;
      }
      const workbook = XLSX.read(evt.target.result, { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });
      this.props.postCsvFileToDeleteContacts(jsonData, this.props.auth.user.establishments[0].id);
    };
    if (isCsv) {
      reader.readAsText(file, 'UTF-8');
    } else {
      reader.readAsBinaryString(file);
    }
  };

  downloadTemplate = (fileType) => {
    const isPublic = this.props.auth.user?.establishments?.[0].stations?.[0].public;
    const header = isPublic
      ? ['Nome', 'Email', 'CPF', 'Data de Nascimento', 'UF', 'Celular', 'Entidades']
      : ['CPF', 'Associado', 'Empregado', 'Email'];
    const examples = isPublic
      ? [
          [
            'Maria da Silva',
            'maria.silva@exemplo.com',
            '12345678901',
            '01/01/1990',
            'DF',
            '61999999999',
            'Entidade 1,Entidade 2',
          ],
          // Entidades pode ficar em branco quando o contato não pertence a nenhuma
          [
            'João Souza',
            'joao.souza@exemplo.com',
            '98765432100',
            '02/02/1985',
            'SP',
            '11988888888',
            '',
          ],
        ]
      : [['12345678901', 'sim', 'nao', 'maria.silva@exemplo.com']];

    const worksheet = XLSX.utils.aoa_to_sheet([header, ...examples]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Contatos');

    const fileName = `modelo-importacao-contatos.${fileType}`;
    XLSX.writeFile(workbook, fileName, { bookType: fileType });
  };

  downloadDeleteTemplate = (fileType) => {
    const header = ['CPF', 'Email'];
    const examples = [
      ['12345678901', 'maria.silva@exemplo.com'],
      // basta preencher CPF ou Email; a outra coluna pode ficar em branco
      ['98765432100', ''],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([header, ...examples]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Excluir Contatos');

    const fileName = `modelo-exclusao-contatos.${fileType}`;
    XLSX.writeFile(workbook, fileName, { bookType: fileType });
  };

  handleFinishImport = () => {
    const first_time = this.props.location.query.first_contacts;
    const hasErrors = this.props.contacts.errors?.length > 0;
    this.props.clearCsvImportResults();
    this.setState({ import: '' });
    if (this.props.router) {
      if (hasErrors) {
        this.props.router.push(first_time ? '/owner/contacts/?first_time=true' : '/owner/contacts');
      } else {
        this.props.router.push(
          first_time
            ? '/owner/contacts/credenciados/?first_time=true'
            : '/owner/contacts/credenciados'
        );
      }
    }
  };

  handleFinishDelete = () => {
    this.props.clearCsvDeleteResults();
    this.setState({ import: '' });
  };

  onSubmit = async (values) => {
    const { auth, router } = this.props;
    const newValues = {
      establishment: auth.user.establishments[0].id,
      contacts: [values],
    };
    const first_time = this.props.location.query.first_contacts;
    await this.props.postContacts(newValues, router, first_time);

    if (this.props.auth.user) {
      await this.props.validateToken(
        JSON.parse(localStorage.getItem(USER_TOKEN)),
        this.props.auth.user.id
      );
    }
  };

  render() {
    const { contacts } = this.props;

    const { handleSubmit } = this.props;
    if (contacts.loading) {
      return (
        <div className="d-flex justify-content-center mt-5">
          <LoadingProgress />
        </div>
      );
    }
    return (
      <section className="modules">
        <MaterialGrid container spacing={2} direction="row" justify="center" alignItems="center">
          <MaterialGrid item>
            <OnboardingCard
              condition={false}
              onClickButton={() => this.setState({ import: 'csv' })}
              title="Cadastre novos participantes"
              text="produza um arquivo no formato .csv ou Excel (veja o modelo) e faça upload dos seus participantes aqui."
              router={this.props.router}
              buttonLabel="Iniciar Inclusão"
            />
          </MaterialGrid>
          <MaterialGrid item>
            <OnboardingCard
              condition={false}
              onClickButton={() => this.setState({ import: 'manual' })}
              title="Inclua participantes manualmente"
              text="Utilize o formulário para importar um participante"
              router={this.props.router}
              buttonLabel="Iniciar Inclusão"
            />
          </MaterialGrid>
          <MaterialGrid item>
            <OnboardingCard
              condition={false}
              onClickButton={() => this.setState({ import: 'delete-csv' })}
              title="Exclua participantes do pré-cadastro"
              text="produza um arquivo .csv ou Excel com o CPF (ou Email) dos participantes e remova-os do pré-cadastro em massa."
              router={this.props.router}
              buttonLabel="Iniciar Exclusão"
            />
          </MaterialGrid>
        </MaterialGrid>
        <AlertDialogSlide
          visible={this.state.import === 'csv'}
          title="Importar CSV"
          onClose={() => {
            this.props.clearCsvImportResults();
            this.setState({ import: '' });
          }}>
          {this.props.contacts.importResults?.length > 0 ? (
            <section style={{ margin: 30 }}>
              {this.props.contacts.importResults.some((item) => item.semEmail) && (
                <Box
                  style={{
                    padding: '12px 16px',
                    backgroundColor: '#fff4e5',
                    borderLeft: '4px solid #ff9800',
                    borderRadius: 4,
                    fontSize: 14,
                    color: '#8a4b00',
                    marginBottom: 16,
                  }}>
                  <p style={{ marginBottom: 8 }}>
                    <strong>
                      {this.props.contacts.importResults.filter((item) => item.semEmail).length}
                    </strong>{' '}
                    contato(s) importado(s) sem e-mail. Essas pessoas não conseguirão concluir o
                    primeiro acesso até que o e-mail seja cadastrado:
                  </p>
                  <ul style={{ maxHeight: 150, overflowY: 'auto', marginBottom: 0 }}>
                    {this.props.contacts.importResults
                      .filter((item) => item.semEmail)
                      .map((item, index) => (
                        <li key={`sem-email-${item.cpf || 'sem-cpf'}-${index}`}>
                          {item.name ? `${item.name} - ` : ''}
                          {item.cpf ? `CPF ${item.cpf}` : 'sem CPF'}
                        </li>
                      ))}
                  </ul>
                </Box>
              )}
              <p>
                <strong>{this.props.contacts.importResults.length}</strong> contato(s) processado(s)
                com sucesso:
              </p>
              <ul style={{ maxHeight: 300, overflowY: 'auto' }}>
                {this.props.contacts.importResults.map((item, index) => (
                  <li key={`${item.cpf || 'sem-cpf'}-${index}`}>
                    {item.name ? `${item.name} - ` : ''}
                    {item.cpf ? `CPF ${item.cpf} - ` : ''}
                    {item.status === 'created' ? 'Novo contato' : 'Contato atualizado'}
                    {item.semEmail ? ' (sem e-mail)' : ''}
                  </li>
                ))}
              </ul>
              <Box display="flex" justifyContent="flex-end">
                <PrimaryButton onClick={this.handleFinishImport}>Concluir</PrimaryButton>
              </Box>
            </section>
          ) : (
            <section style={{ margin: 30 }}>
              <Box
                style={{
                  padding: '12px 16px',
                  backgroundColor: '#e3f2fd',
                  borderLeft: '4px solid #2196f3',
                  borderRadius: 4,
                  fontSize: 14,
                  color: '#1976d2',
                  marginBottom: 16,
                }}>
                {this.props.auth.user?.establishments?.[0].stations?.[0].public ? (
                  <>
                    O arquivo (.csv, .xlsx ou .xls) precisa ter uma linha de cabeçalho com
                    exatamente estas colunas: <strong>Nome</strong>, <strong>Email</strong>,{' '}
                    <strong>CPF</strong> (apenas números, sem pontuação),{' '}
                    <strong>Data de Nascimento</strong> (formato dd/MM/yyyy, ex: 01/01/1990),{' '}
                    <strong>UF</strong>, <strong>Celular</strong> (apenas números) e{' '}
                    <strong>Entidades</strong> (opcional). Se o contato pertencer a mais de uma
                    entidade, separe os nomes por vírgula sem espaço (ex: "Entidade 1,Entidade 2") e
                    escreva o nome exatamente como cadastrado na área de Entidades. Caso o contato
                    não pertença a nenhuma entidade, deixe a coluna em branco. Baixe o modelo abaixo
                    para preencher no formato correto.
                  </>
                ) : (
                  <>
                    O arquivo (.csv, .xlsx ou .xls) precisa ter uma linha de cabeçalho com
                    exatamente estas colunas: <strong>CPF</strong> (apenas números, sem pontuação),{' '}
                    <strong>Email</strong>, <strong>Associado</strong> e <strong>Empregado</strong>{' '}
                    (use "sim" ou "não" nessas duas últimas). O e-mail pode ficar em branco, mas o
                    participante sem e-mail não consegue concluir o primeiro acesso. Baixe o modelo
                    abaixo para preencher no formato correto.
                  </>
                )}
              </Box>
              <Box display="flex" style={{ gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
                <PrimaryButton onClick={() => this.downloadTemplate('csv')}>
                  Baixar modelo CSV
                </PrimaryButton>
                <PrimaryButton onClick={() => this.downloadTemplate('xlsx')}>
                  Baixar modelo Excel
                </PrimaryButton>
              </Box>
              <Dropzone
                onDrop={(acceptedFiles) => this.handleFile(acceptedFiles)}
                accept=".csv,.xlsx,.xls">
                {({ getRootProps, getInputProps }) => (
                  <div
                    className="row align-items-center"
                    {...getRootProps()}
                    style={{
                      width: '100%',
                      height: 250,
                      borderWidth: 2,
                      borderColor: 'rgb(102, 102, 102)',
                      borderStyle: 'dashed',
                      borderRadius: 5,
                      margin: 'auto',
                      cursor: 'pointer',
                    }}>
                    <input {...getInputProps()} />
                    <center className="justify-content-center">
                      Arraste aqui (ou clique para selecionar) o arquivo .csv, .xlsx ou .xls com
                      seus contatos.
                    </center>
                  </div>
                )}
              </Dropzone>
              {this.state.fileError && (
                <Box style={{ color: '#d32f2f', marginTop: 8, fontSize: 13 }}>
                  {this.state.fileError}
                </Box>
              )}
            </section>
          )}
        </AlertDialogSlide>
        <AlertDialogSlide
          visible={this.state.import === 'delete-csv'}
          title="Excluir contatos do pré-cadastro"
          onClose={() => {
            this.props.clearCsvDeleteResults();
            this.setState({ import: '' });
          }}>
          {this.props.contacts.deleteResults?.length > 0 ||
          this.props.contacts.deleteErrors?.length > 0 ? (
            <section style={{ margin: 30 }}>
              {this.props.contacts.deleteResults?.length > 0 && (
                <>
                  <p>
                    <strong>{this.props.contacts.deleteResults.length}</strong> contato(s)
                    excluído(s) do pré-cadastro:
                  </p>
                  <ul style={{ maxHeight: 200, overflowY: 'auto' }}>
                    {this.props.contacts.deleteResults.map((item, index) => (
                      <li key={`${item.cpf || item.email || 'sem-cpf'}-${index}`}>
                        {item.cpf ? `CPF ${item.cpf}` : item.email}
                      </li>
                    ))}
                  </ul>
                </>
              )}
              {this.props.contacts.deleteErrors?.length > 0 && (
                <>
                  <p>Não foi possível excluir:</p>
                  <ul style={{ maxHeight: 200, overflowY: 'auto', color: '#d32f2f' }}>
                    {this.props.contacts.deleteErrors.map((item, index) => (
                      <li key={`delete-error-${index}`}>{item}</li>
                    ))}
                  </ul>
                </>
              )}
              <Box display="flex" justifyContent="flex-end">
                <PrimaryButton onClick={this.handleFinishDelete}>Concluir</PrimaryButton>
              </Box>
            </section>
          ) : (
            <section style={{ margin: 30 }}>
              <Box
                style={{
                  padding: '12px 16px',
                  backgroundColor: '#fdecea',
                  borderLeft: '4px solid #d32f2f',
                  borderRadius: 4,
                  fontSize: 14,
                  color: '#c62828',
                  marginBottom: 16,
                }}>
                O arquivo (.csv, .xlsx ou .xls) precisa ter uma linha de cabeçalho com a coluna{' '}
                <strong>CPF</strong> (apenas números, sem pontuação) ou <strong>Email</strong>{' '}
                identificando quem deve ser removido do pré-cadastro. A exclusão é reversível apenas
                reimportando o contato novamente.
              </Box>
              <Box display="flex" style={{ gap: 12, flexWrap: 'wrap', marginBottom: 16 }}>
                <PrimaryButton onClick={() => this.downloadDeleteTemplate('csv')}>
                  Baixar modelo CSV
                </PrimaryButton>
                <PrimaryButton onClick={() => this.downloadDeleteTemplate('xlsx')}>
                  Baixar modelo Excel
                </PrimaryButton>
              </Box>
              <Dropzone
                onDrop={(acceptedFiles) => this.handleDeleteFile(acceptedFiles)}
                accept=".csv,.xlsx,.xls">
                {({ getRootProps, getInputProps }) => (
                  <div
                    className="row align-items-center"
                    {...getRootProps()}
                    style={{
                      width: '100%',
                      height: 250,
                      borderWidth: 2,
                      borderColor: 'rgb(102, 102, 102)',
                      borderStyle: 'dashed',
                      borderRadius: 5,
                      margin: 'auto',
                      cursor: 'pointer',
                    }}>
                    <input {...getInputProps()} />
                    <center className="justify-content-center">
                      Arraste aqui (ou clique para selecionar) o arquivo .csv, .xlsx ou .xls com os
                      contatos a excluir.
                    </center>
                  </div>
                )}
              </Dropzone>
              {this.state.deleteFileError && (
                <Box style={{ color: '#d32f2f', marginTop: 8, fontSize: 13 }}>
                  {this.state.deleteFileError}
                </Box>
              )}
            </section>
          )}
        </AlertDialogSlide>
        <AlertDialogSlide
          visible={this.state.import === 'manual'}
          title="Digite CPF do contato"
          height="95vh"
          maxWidth="sm"
          onClose={() => {
            this.setState({ import: '' });
          }}>
          <Form role="form" onSubmit={handleSubmit(this.onSubmit)} noValidate>
            <MaterialGrid container spacing={3}>
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label="CPF"
                  name="cpf"
                  required
                  validate={[FORM_RULES.required]}
                  {...cpfMask}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12}>
                <Field
                  component={InputLabelOutlined}
                  label="Email"
                  name="email"
                  validate={[FORM_RULES.email]}
                />
              </MaterialGrid>
              <MaterialGrid item xs={12}>
                <Box display="flex" alignItems="center" style={{ height: '100%' }}>
                  <Field component={InputSwitch} label={'É associado?'} name="associated" />
                </Box>
              </MaterialGrid>
              <MaterialGrid item xs={12}>
                <Box display="flex" alignItems="center" style={{ height: '100%' }}>
                  <Field component={InputSwitch} label={'É empregado?'} name="internal" />
                </Box>
              </MaterialGrid>
            </MaterialGrid>
            <MaterialGrid container spacing={3} justify="center">
              <MaterialGrid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  <PrimaryButton
                    type="submit"
                    disabled={this.props.contacts.buttonLoading}
                    progress={parseInt(this.props.general.submitProgress)}>
                    {this.props.contacts.buttonLoading ? 'Enviando' : 'Enviar'}
                  </PrimaryButton>
                </Box>
              </MaterialGrid>
            </MaterialGrid>
          </Form>
        </AlertDialogSlide>
      </section>
    );
  }
}

ContactForm.propTypes = {
  auth: PropTypes.shape({
    user: PropTypes.shape({
      establishments: PropTypes.any,
      id: PropTypes.any,
    }),
  }),
  contacts: PropTypes.shape({
    buttonLoading: PropTypes.any,
    loading: PropTypes.any,
    errors: PropTypes.array,
    importResults: PropTypes.array,
    deleteResults: PropTypes.array,
    deleteErrors: PropTypes.array,
  }),
  general: PropTypes.shape({
    submitProgress: PropTypes.any,
  }),
  handleSubmit: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      first_contacts: PropTypes.any,
    }),
  }),
  postContacts: PropTypes.func,
  postCsvFileToContacts: PropTypes.func,
  clearCsvImportResults: PropTypes.func,
  postCsvFileToDeleteContacts: PropTypes.func,
  clearCsvDeleteResults: PropTypes.func,
  router: PropTypes.any,
  validateToken: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    contacts: state.contacts,
    general: state.general,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      postCsvFileToContacts,
      postContacts,
      validateToken,
      clearCsvImportResults,
      postCsvFileToDeleteContacts,
      clearCsvDeleteResults,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: 'ContactForm' })(ContactForm));
